import { memoize, template } from 'lodash'

export const dynamicTemplate = (templateString: string | undefined, templateValues: object) => {
  if (templateString) {
    return compiledTemplate(templateString)(templateValues)
  }

  return ''
}

export const compiledTemplate = memoize((templateString) => {
  return template(templateString)
})
